import { render, staticRenderFns } from "./SchoolClassList.vue?vue&type=template&id=d235e654&scoped=true"
import script from "./SchoolClassList.vue?vue&type=script&lang=js"
export * from "./SchoolClassList.vue?vue&type=script&lang=js"
import style0 from "./SchoolClassList.vue?vue&type=style&index=0&id=d235e654&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d235e654",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d235e654')) {
      api.createRecord('d235e654', component.options)
    } else {
      api.reload('d235e654', component.options)
    }
    module.hot.accept("./SchoolClassList.vue?vue&type=template&id=d235e654&scoped=true", function () {
      api.rerender('d235e654', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/schoolClass/SchoolClassList.vue"
export default component.exports